const Financing = Object.freeze({
  CLEAR: 'CLEAR',
  CLARIFICATION: 'CLARIFICATION',
  UNCLEAR: 'UNCLEAR',
  CONSULTING_NEEDED: 'CONSULTING_NEEDED',
})

export default Financing
